import { useCallback } from 'react';
import isEmpty from 'lodash/isEmpty';
import xor from 'lodash/xor';

interface IUseFilterStateOptions {
  getCurrentAbbreviations: (filterKey: string) => string[],
}

interface IUseFilterStateResult {
  toggleFilter: (filterKey: string, abbreviation: string, allowEmpty?: boolean) => string[] | null,
  getActiveFilters: (filterKey: string) => string[],
}

export const useFilterState = ({
  getCurrentAbbreviations,
}: IUseFilterStateOptions): IUseFilterStateResult => {
  const toggleFilter = useCallback((
    filterKey: string,
    abbreviation: string,
    allowEmpty: boolean = false,
  ): string[] | null => {
    const currentAbbreviations = getCurrentAbbreviations(filterKey);
    const selectedFilterList = xor(currentAbbreviations, [abbreviation]);

    if (!allowEmpty && isEmpty(selectedFilterList)) {
      return null;
    }

    return selectedFilterList;
  }, [getCurrentAbbreviations]);

  const getActiveFilters = useCallback((filterKey: string): string[] => {
    return getCurrentAbbreviations(filterKey);
  }, [getCurrentAbbreviations]);

  return {
    toggleFilter,
    getActiveFilters,
  };
};
